import React from 'react'

import { graphql, useLazyLoadQuery } from 'react-relay'
import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react/macro'
import { useScreenMessages } from '@data/i18n'
import { Metadata } from '@newComponents/Metadata'
import { Screen } from '@newComponents/Screen'
import { Grid, SponsorsSection, Paragraph, H2 } from '@newComponents'
import { YStack, Separator } from 'tamagui'
import { PresentationsScreenListSection } from './PresentationsScreenListSection'
import { PresentationsScreenQuery } from './__generated__/PresentationsScreenQuery.graphql'

export const PresentationsScreen = () => {
  useScreenMessages(
    (locale) =>
      import(
        /* webpackChunkName: "locale-presentations-screen-[request]" */ `./locales/${locale}.po`
      )
  )
  const { t } = useLingui()

  const data = useLazyLoadQuery<PresentationsScreenQuery>(
    graphql`
      query PresentationsScreenQuery {
        ...PresentationsScreenListSection_query

        ...SponsorsSection_query
      }
    `,
    {}
  )

  return (
    <>
      <Metadata title={t`Explore Presentations`} />

      <Screen>
        <YStack gap={100} $gtMd={{ display: 'none' }}>
          <YStack gap='$6'>
            <H2>
              <Trans>Explore Presentations</Trans>
            </H2>

            <PresentationsScreenListSection query={data} />
          </YStack>

          <Separator borderColor='$borderColor' paddingHorizontal='$4' />

          <SponsorsSection query={data} padding='$4' />
        </YStack>

        <Grid gap='$8' display='none' $gtMd={{ display: 'flex' }}>
          <Grid.Column gap='$6' flexGrow={2} $gtMd={{ flexGrow: 3 }}>
            <H2>
              <Trans>Explore Presentations</Trans>
            </H2>

            <PresentationsScreenListSection query={data} />
          </Grid.Column>

          <Grid.Column gap='$4' flexGrow={1}>
            <YStack
              gap='$8'
              padding='$4'
              style={{ position: 'sticky', top: 144.90625 }}
            >
              <YStack
                gap='$4'
                $gtMdHt={{ display: 'flex' }}
                $mdHt={{ display: 'none' }}
              >
                <Paragraph size='$4' color='$color'>
                  <Trans>
                    Watch talks and Presentations from your favorite Guilds and
                    Events
                  </Trans>
                </Paragraph>

                <Paragraph size='$4' color='$color'>
                  <Trans>Thanks to our sponsors for making it possible</Trans>{' '}
                  👇
                </Paragraph>
              </YStack>

              <SponsorsSection query={data} />
            </YStack>
          </Grid.Column>
        </Grid>
      </Screen>
    </>
  )
}

export default PresentationsScreen
